// extracted by mini-css-extract-plugin
export var content = "_nr-1";
export var fullScreen = "_nr-0";